(() => {
  const menuButton = document.querySelector('[data-menu-open]');
  const panel = document.querySelector('[data-mobile-panel]');
  const closeButton = document.querySelector('[data-menu-close]');

  const closeMenu = () => {
    if (!panel || !menuButton) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    menuButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
    menuButton.focus();
  };

  const openMenu = () => {
    if (!panel || !menuButton) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    menuButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
    closeButton?.focus();
  };

  menuButton?.addEventListener('click', openMenu);
  closeButton?.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel?.classList.contains('is-open')) closeMenu();
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const optionSelects = [...form.querySelectorAll('[data-option-select]')];
    const variantsElement = form.querySelector('[data-product-variants]');
    const variantInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-button]');
    const price = document.querySelector('[data-product-price]');
    const personalizationPanel = form.querySelector('[data-personalization-panel]');
    const personalizationInput = form.querySelector('[data-personalization-input]');
    const engravingOptions = form.querySelector('[data-engraving-options]');
    const engravingSelect = form.querySelector('[data-engraving-select]');
    const isEngravingProduct = form.dataset.engravingProduct === 'true';
    let variants = [];

    if (variantsElement) {
      try { variants = JSON.parse(variantsElement.textContent); }
      catch { variants = []; }
    }

    const sameValue = (left, right) => String(left).trim().toLocaleLowerCase() === String(right).trim().toLocaleLowerCase();
    const isEngravedExecution = (value) => {
      const normalized = String(value).trim().toLocaleLowerCase();
      return normalized.includes('gravur') && !normalized.includes('ohne gravur');
    };

    const updatePersonalization = () => {
      if (!personalizationPanel || personalizationPanel.dataset.conditional !== 'true') return;
      const trigger = personalizationPanel.dataset.triggerValue || '';
      const conditionalMode = personalizationPanel.dataset.conditionalMode || 'value';
      const visible = conditionalMode === 'personalized-option'
        ? optionSelects.some((select) => !select.value.toLocaleLowerCase().includes('ohne gravur'))
        : engravingSelect
          ? sameValue(engravingSelect.value, trigger)
          : optionSelects.some((select) => sameValue(select.value, trigger));
      personalizationPanel.hidden = !visible;
      personalizationPanel.setAttribute('aria-hidden', String(!visible));
      if (personalizationInput) {
        personalizationInput.disabled = !visible;
        personalizationInput.required = visible && personalizationInput.dataset.requiredWhenVisible === 'true';
        if (!visible) personalizationInput.value = '';
      }
    };

    const updateEngravingOptions = () => {
      if (!isEngravingProduct || !engravingOptions || !engravingSelect) return;
      const execution = optionSelects[0]?.value || '';
      const visible = isEngravedExecution(execution);
      engravingOptions.hidden = !visible;
      engravingOptions.setAttribute('aria-hidden', String(!visible));
      engravingSelect.disabled = !visible;
      engravingSelect.required = visible;
      if (!visible) engravingSelect.value = '';
    };

    const normalizeOptions = () => {
      optionSelects.forEach((select, index) => {
        const position = Number(select.dataset.optionPosition) - 1;
        const prefix = optionSelects.slice(0, index).map((entry) => ({ position: Number(entry.dataset.optionPosition) - 1, value: entry.value }));
        [...select.options].forEach((option) => {
          option.disabled = !variants.some((variant) => variant.available && sameValue(variant.options[position], option.value) && prefix.every((entry) => sameValue(variant.options[entry.position], entry.value)));
        });
        if (select.selectedOptions[0]?.disabled) {
          const firstAvailable = [...select.options].find((option) => !option.disabled);
          if (firstAvailable) select.value = firstAvailable.value;
        }
      });
    };

    const updateVariant = () => {
      if (!optionSelects.length || !variants.length) {
        updatePersonalization();
        return;
      }
      normalizeOptions();
      const selections = optionSelects.map((select) => ({ position: Number(select.dataset.optionPosition) - 1, value: select.value }));
      const candidates = variants.filter((entry) => entry.available && selections.every((selection) => sameValue(entry.options[selection.position], selection.value)));
      const variant = isEngravingProduct ? candidates.find((entry) => entry.options.some((value) => sameValue(value, 'Ohne Gravur'))) || candidates[0] : candidates[0];
      const available = Boolean(variant?.available);
      if (variantInput) variantInput.value = variant?.id || '';
      if (price && variant?.price) price.textContent = variant.price;
      if (button) {
        button.disabled = !available;
        const label = button.querySelector('span');
        if (label) label.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
      }
      if (variant?.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      updateEngravingOptions();
      updatePersonalization();
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
    engravingSelect?.addEventListener('change', updatePersonalization);
    updateVariant();

    form.addEventListener('submit', (event) => {
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
      }
    });
  });
})();
